import React, { useEffect, useState } from 'react'
import { Box, Container, Stack, Typography } from '@mui/material'
import PropaneOutlinedIcon from '@mui/icons-material/PropaneOutlined';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import { customStyles, spaceBetween } from '../../../styles';
import { LightText, RegularText, SmallText } from '../../helpers';
import { SecondaryText } from '../../helpers/text/SecondaryText';
import { PreviewStackContainer } from './PreviewStackContainer';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const style = {
   color: customStyles.colors.main, 
   marginRight: 3
}
export const YourService = () => {
   const { service, quantity, subTotal, account } = useSelector(state => state.order)
   const { typeService,  } = useSelector(state => state.accounts)
   const { type } = service
   const navigate = useNavigate()
   const [formatNumber, setFormatNumber] = useState(null)

   const handleNavigate = () => {
    navigate(`/dashboard/${account?.id}/${service?.type.toLowerCase()}`)  
   }

   useEffect(() => {
      setFormatNumber( Intl.NumberFormat('es-MX') )
    }, [])
  return (
   <PreviewStackContainer text="Tu servicio" direction="column">  
      {/* <Stack width="100%" spacing={2}>
         <Box sx={ {...spaceBetween, width:  "100%"} }>
            <Box sx={ spaceBetween } width="25%">
               <PropaneOutlinedIcon sx={style}/>
              <Typography component="p" variant="body1">Gas {type === 'PORTATIL' ? 'Cilindro' : 'Estacionario' }</Typography> 
            </Box>
            <ModeEditOutlineOutlinedIcon sx={{ color: customStyles.colors.textColor, cursor: 'pointer' }} onClick={handleNavigate}/>
         </Box>
         <Box sx={ {...spaceBetween, width:  "100%"} }>
            <Box sx={ spaceBetween } width="25%">
               <PropaneOutlinedIcon sx={style}/>
               <Typography component="p" variant="body1">{type}</Typography> 
               <Typography component="p" variant="body1" sx={{ color: customStyles.colors.textColor }}>{quantity}</Typography> 
               
            </Box>
            <Typography component="p" variant="body1" sx={{ color: customStyles.colors.main }}>$ {formatNumber?.format(subTotal)} MXN</Typography> 
            
         </Box>
      </Stack> */}
      <Stack direction="row" justifyContent="space-between" width="100%">
         <Stack direction="row" alignItems="center">
            {
               type === 'PORTATIL'
               ? <PropaneTankIcon sx={style}/>
               : <PropaneOutlinedIcon sx={style}/>
            }
            <RegularText text={`Gas ${type === 'PORTATIL' ? 'Cilindro' : 'Estacionario'}`} />
         </Stack> 
         <ModeEditOutlineOutlinedIcon sx={{ color: customStyles.colors.textColor, cursor: 'pointer' }} onClick={handleNavigate}/>   
      </Stack>

      <Stack direction="row" justifyContent="space-between" width="100%" pl={6}>
            <SmallText text={`Precio por ${type === 'PORTATIL' ? 'Cilindro' : 'Litro'}`} color={customStyles.colors.textColor} />
            <SmallText text={`$${ service?.price } ${type === 'PORTATIL' ? 'c/u' : 'lt'}`} bold color={customStyles.colors.textColor} />
      </Stack>
      <Stack direction="row" justifyContent="space-between" width="100%" pl={6} bold>
            <RegularText text={ type === 'PORTATIL' ? 'Unidad' : 'Litros' } />
            <RegularText text={`${quantity} ${type === 'ESTACIONARIO' ? 'lt' : ''}`}  color={customStyles.colors.textColor} />
            <RegularText text={`$${subTotal} MXN`} bold color={customStyles.colors.main} />
      </Stack>
   </PreviewStackContainer>
  )
}
